import { ArchiveMaterialInfo } from './archive-material-info.enum';

export enum ArchiveTitleRuleItemType {
  PROJECT = 'PROJECT',
  DESIGN = 'DESIGN',
  SUPERVISION = 'SUPERVISION',
  CONSTRUCTION = 'CONSTRUCTION',
  SPOT_CHECK = 'SPOT_CHECK',
  JG_CHECK = 'JG_CHECK',
  COMPLETED_CHECK = 'COMPLETED_CHECK',
  DW = 'DW',
  FB = 'FB',
  SUB_FB = 'SUB_FB',
  FX = 'FX',
  SECTION = 'SECTION',
  SEGMENT = 'SEGMENT',
  LAYER = 'LAYER',
  MATERIAL = 'MATERIAL',
  FORM_FREE_HEAD = 'FORM_FREE_HEAD',
  SUBMIT_DATE = 'SUBMIT_DATE',
  FINISH_DATE = 'FINISH_DATE',
}

export enum ArchiveTitleRuleItemDisplayType {
  PROJECT = 'PROJECT',
  DESIGN = 'DESIGN',
  SUPERVISION = 'SUPERVISION',
  CONSTRUCTION = 'CONSTRUCTION',
  SPOT_CHECK = 'SPOT_CHECK',
  JG_CHECK = 'JG_CHECK',
  COMPLETED_CHECK = 'COMPLETED_CHECK',
  DW = 'DW',
  FB = 'FB',
  SUB_FB = 'SUB_FB',
  FX = 'FX',
  SECTION = 'SECTION',
  SEGMENT = 'SEGMENT',
  LAYER = 'LAYER',
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  MATERIAL_MODEL = 'MATERIAL_MODEL',
  MATERIAL_YEAR = 'MATERIAL_YEAR',
  FORM_FREE_HEAD = 'FORM_FREE_HEAD',
  SUBMIT_DATE = 'SUBMIT_DATE',
  FINISH_DATE = 'FINISH_DATE',
}
